$(document).ready(function(){
	// Check if element has hidden content
	$(".brands-detail").each(function() {
		var $el = $(this)
		var $body = $el.find(".content-body");
		var overflowed = $body[0].scrollHeight > $body[0].clientHeight;

		if(!overflowed) {
			$(".brands-detail-body-text").addClass("mb-40");
			$(".showLessButton").addClass('hide');
			$(".showMoreButton").addClass('hide');
			$(".showLess").addClass('hide');
		} else {
			$(".showMoreButton").on("click", function() {
				$(".showLess").toggleClass("hide");
				$(".showMoreButton").toggleClass("hide");
				$(".showLessButton").toggleClass("hide");
				$(".content-body").toggleClass("expanded");
			});
			$(".showLessButton").on("click", function() {
				$(".showLess").toggleClass("hide");
				$(".showMoreButton").toggleClass("hide");
				$(".showLessButton").toggleClass("hide");
				$(".content-body").toggleClass("expanded");
			});
		}
	});
});


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/pages/brands-detail.js
// module id = 28
// module chunks = 0